var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 0.5,
    width: 21,
    height: 21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3421 2.04655C17.4961 1.58052 16.5258 1.3125 15.4907 1.3125C13.6643 1.3125 12.0286 2.14479 10.9486 3.44987C9.86351 2.14479 8.22942 1.3125 6.40053 1.3125C5.36785 1.3125 4.39936 1.58052 3.55153 2.04655C1.73247 3.05396 0.5 4.99082 0.5 7.2167C0.5 7.85394 0.603695 8.46508 0.791508 9.03682C1.80437 13.5897 10.9486 19.3317 10.9486 19.3317C10.9486 19.3317 20.0868 13.5898 21.1011 9.03682C21.2889 8.46508 21.3937 7.85311 21.3937 7.2167C21.3937 4.99165 20.1612 3.05538 18.3421 2.04655Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.0fc9b04ecf86aa7427e48784c11a2df6.svg";
export { ForwardRef as ReactComponent };